import {useCallback, useEffect, useState} from "preact/compat";
import {useAppContext, useUserContext} from "../../contexts";
import {api} from "../../services";
import {route} from "preact-router";

export const useUserOrderDetails = (props) => {
    const {id} = props;

    // State to control the fetch loader
    const [isFetching, setIsFetching] = useState(true);
    const [descriptionIsOpen, setDescriptionIsOpen] = useState(false);

    // State to control the fetch data
    const [order, setOrder] = useState({});
    const [formattedStatus, setFormattedStatus] = useState('');
    const [formattedMessage, setFormattedMessage] = useState('');
    const [cancelData, setCancelData] = useState({});

    // Retrieves the flag that tells if user is logged in or not
    const [{isSignedIn}] = useUserContext();

    const {
        setFullPageLoader,
        handleDocumentTitle
    } = useAppContext();

    const handleDescriptionIsOpen = () => {
        setDescriptionIsOpen((prevState) => !prevState);
    }

    const formatDate = (inputDateTime = '') => {
        // Split the date and time parts
        const [datePart, _timePart] = inputDateTime.split(' ');

        // Extract year, month, and day from the date
        const [year, month, day] = datePart.split('-');

        // Returns the formatted date as "dd/mm/yyyy"
        return `${day}/${month}/${year}`;
    }

    const handleFormattedInfos = () => {
        switch (order.status) {
            case 'pending':
            case 'pending_payment':
            case 'holded':
                setFormattedStatus('Aguardando pagamento');
                setFormattedMessage('Recebemos o seu pedido :) Aguarde a aprovação para seguir com o atendimento.');

                break;
            case 'processing':
            case 'partially_scheduled':
            case 'partially_applied':
            case 'scheduled':
            case 'authorized':
            case 'complete':
            case 'finished':
                setFormattedStatus('Pedido Autorizado');
                setFormattedMessage('Seu pedido já está disponivel para utilização, basta imprimir o voucher.');

                break;
            case 'canceled':
                setFormattedMessage('Pedido Cancelado');
                setFormattedMessage('Infelizmente o seu pedido foi cancelado, não recebemos seu pagamento.');

                break;
            case 'processing_cancel':
                setFormattedStatus('Em processo de cancelamento');
                setFormattedMessage('');

                break;
            default:
                setFormattedMessage('');
                setFormattedMessage('');

                break;
        }
    }

    const formatPrice = (price) => {
        if (typeof price === 'number') {
            price = price.toFixed(2);
        } else {
            price = parseFloat(price).toFixed(2);
        }

        // Split the integer part from the decimal part
        const parts = price.split('.');

        let integerPart = parts[0];
        let decimalPart = parts[1];

        // Format the integer part with a thousand separators
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return `${integerPart},${decimalPart}`;
    };

    const convertEscapedHTML = (html) => {
        const element = document.createElement("textarea");
        element.innerHTML = html;
        element.innerHTML = element.innerHTML.replace('<br>', ' ');
        element.innerHTML = element.innerHTML.replace(';', '');

        return element.value
            .replace(/<br>/g, "\n")
            .replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/(\r\n|\r|\n){2,}/g, "\n")
            .split(";");
    }

    // Performs the initial page operations
    const initialOperations = useCallback(async () => {
        // Validates if user is logged in and, if it's not, then it redirects to the login page
        if (!isSignedIn) {
            route("/entre?fallback=user-account");
        }

        try {
            setFullPageLoader(true);
            // Waits to mock response time from the backend
            const {data} = await api.get(`/v1/customer/orders?id=${id}`);

            setOrder(data?.result?.items);
            setCancelData(data?.result.cancelData);
        } catch (err) {
            console.error('Erro ao buscar os produtos:', err);
        } finally {
            setIsFetching(false);
            setFullPageLoader(false);
        }

    }, [isSignedIn]);

    // Effect to trigger the initial operations
    useEffect(() => {
        initialOperations().then();

        // Updates the page title
        handleDocumentTitle("Detalhes do Pedido");
    }, [initialOperations, isSignedIn]);

    useEffect(async () => {
        handleFormattedInfos();
    }, [order]);

    return {
        order,
        isFetching,
        formattedStatus,
        formattedMessage,
        formatDate,
        formatPrice,
        cancelData,
        convertEscapedHTML,
        descriptionIsOpen,
        handleDescriptionIsOpen,
    }
}
